// Transitional bridge: maps legacy icon names (still used across call sites) to their Lucide
// outline equivalents. Meant to shrink and eventually be removed as call sites adopt the canonical
// Lucide names directly — same migration phase as the `icon_variant` setting and the solid fallback.
export const ICON_ALIASES: Readonly<Record<string, string>> = {
  "academic-cap": "graduation-cap",
  adjustments: "sliders-vertical",
  apply: "check",
  "arrow-circle-left": "circle-arrow-left",
  "arrow-circle-up": "circle-arrow-up",
  "arrow-left-bold": "arrow-left",
  "arrows-expand": "expand",
  "bookmark-solid": "bookmark",
  bulk: "boxes",
  cart: "shopping-cart",
  "cart-2": "shopping-cart",
  "cart-check": "shopping-cart",
  case: "briefcase",
  cash: "banknote",
  chat: "message-circle",
  "check-bold": "check",
  "chevron-double-left": "chevrons-left",
  "chevron-double-right": "chevrons-right",
  "chevron-up-thin": "chevron-up",
  "circle-outline": "circle",
  clear: "eraser",
  "clipboard-arrow": "clipboard-copy",
  collection: "layers",
  compare: "git-compare-arrows",
  cube: "box",
  "cube-transparent": "box",
  cup: "trophy",
  "cursor-click": "mouse-pointer-click",
  "dashboard-2": "layout-dashboard",
  delete: "circle-x",
  "delete-2": "x",
  "delete-thin": "x",
  "desktop-computer": "monitor",
  "direct-login": "log-in",
  "document-add": "file-plus",
  "document-duplicate": "files",
  "document-text": "file-text",
  "dots-vertical": "ellipsis-vertical",
  "drag-dots": "grip",
  "exclamation-circle": "circle-alert",
  fire: "flame",
  "information-circle": "info",
  "list-v2": "heart",
  "location-marker": "map-pin",
  "lock-closed": "lock",
  logout: "log-out",
  notification: "bell",
  "notification-non-active": "bell-off",
  "notification-v2": "bell-ring",
  order: "file-text",
  pass: "key-round",
  "pencil-alt": "square-pen",
  "plus-circle-outlined": "circle-plus",
  process: "refresh-cw",
  profile: "id-card",
  "purchase-request": "receipt",
  "receipt-refund": "undo-2",
  "receipt-tax": "ticket-percent",
  reset: "rotate-ccw",
  "round-check": "circle-check",
  "save-v2": "save",
  "source-environment": "building-2",
  "switch-vertical": "arrow-up-down",
  "user-group": "users",
  // grid & view-grid intentionally map to the tile-grid glyph; outline/grid.svg is a table icon, not a tile grid
  grid: "layout-grid",
  "view-grid": "layout-grid",
  warning: "triangle-alert",
  whishlist: "star",
};

export function resolveIconName(name: string): string {
  return ICON_ALIASES[name] ?? name;
}
